import type {StackProps} from '@travel-frontend/ui-components';

import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Stack} from '@travel-frontend/ui-components';

type Props = StackProps & {
  gradient?: string;
};

export const Container = styled(Stack)<Props>(
  ({theme, gradient}) => css`
    position: relative;
    border-radius: 5px;
    background: linear-gradient(${gradient});
    overflow: hidden;
    border: 0;
    padding: 20px 16px;
    min-height: 110px;
    width: 100%;
    color: ${theme.colors.contentInversePrimary};
    cursor: pointer;

    ${theme.respondTo(
      'md',
      css`
        flex-wrap: nowrap;
        padding: 0 0 0 16px;
      `
    )}

    ${theme.respondTo(
      'xl',
      css`
        padding: 0 16px 0 16px;
      `
    )}

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: 2px solid ${theme.colors.borderSelection};
      outline-offset: 1px;
    }
  `
);
